export default __webpack_public_path__ + "static/uk_49s_tea-5c1e29404613bdff7062c0c3a3ea8c9f.png";